/*
 * @Description: 谷仓-客户管理模块
 * @Author: cxh
 * @Date: 2022-06-13 16:49:55
 * @LastEditTime: 2023-03-03 11:00:06
 * @LastEditors: mdb
 */
import request from '@/utils/request'
import { AxiosResult, IDParams } from '@/typings/common'
import type { MainBodyParams } from '@/typings/api/customerCenter'

/**
 * 客户代码列表
 */
export function customerCodeGet(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/customerCode/findByPage', data)
}
/**
 * 客户代码导出
 */
export function customerCodeExport(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/customerCode/export', data)
}
/**
 * 客户代码新增
 */
export function customerCodeAdd(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/customerCode', data)
}

/**
 * 客户代码编辑
 */
export function customerCodeEdit(data: any) {
  return request.put<AxiosResult, AxiosResult>('/ofbu/api/customerCode/update', data)
}

/**
 * 客户代码删除
 */
export function customerCodeDelete(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/customerCode/delete', data)
}
/**
 * 客户代码详情
 */
export function customerCodeDetail(id: string) {
  return request.get<AxiosResult, AxiosResult>(`/ofbu/api/customerCode/${id}`)
}
/**
 * 获取客户负责人关联的客户代码列表
 */
export function customerCodeDelectSelect(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/customerCode/getList', data)
}
/**
 * 获取客户关联的客户代码信息
 */
export function getCosIdBindCode(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/customerCode/getCosIdBindCode', data)
}
/**
 * ------------------------------------潜在客户----------------------
 */
/**
 *潜在客户列表
 */
export function potentialList(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/customer/findByPage', data)
}
/**
 *潜在客户列表联系人
 */
export function potentialConcatList(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/customer/findByPage', data)
}
/**
 *潜在客户发送注册链接邮箱
 */
export function sentEmail(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/customer/sentEmail', data)
}
/**
 *潜在客户发送注册链接电话号吗
 */
export function sentMobileMsg(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/customer/sentMobileMsg', data)
}
/**
 *删除
 */
export function potentialDel(data: any) {
  return request.delete<AxiosResult, AxiosResult>('/ofbu/api/customer/delete', { data })
}
/**
 *新增
 */
export function potentialAdd(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/customer', data)
}
/**
 *修改
 */
export function potentialEdit(data: any) {
  return request.put<AxiosResult, AxiosResult>('/ofbu/api/customer', data)
}
/**
 *归档
 */
export function potentialArchive(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/customer/archive', data)
}
/**
 *转移客户
 */
export function potentialTransfer(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/customer/transfer', data)
}
/**
 *详情
 */
export function potentialDetail(cosId: any) {
  return request.get<AxiosResult, AxiosResult>(`/ofbu/api/customer/${cosId}`)
}
/**
 *获取客户关联code详情
 */
export function queryCosArkCodeDeatil(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/customerCode/queryCosArkCode', data)
}
/**
 *获取客户合同详情
 */
export function queryContractDetail(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/customer/queryContract', data)
}
/**
 *获取客户联系人下拉列表
 */
export function customerContactSelect(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/contact/getContacts', data)
}
/**
 *获取客户联系人列表
 */
export function customerContactList(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/contact/page/list', data)
}
/**
 *获取客户联系人编辑
 */
export function customerContactEdit(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/contact/update', data)
}
/**
 *获取客户联系人新增
 */
export function customerContactAdd(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/contact/create', data)
}
/**
 *获取客户联系人删除
 */
export function customerContactDelete(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/contact/delete', data)
}

/**
 *获取客户下拉列表
 */
export function findCusNameRelByPage(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/customer/name/getCustomerPage', data)
}
/**
 *客户转签约
 */
export function turnedContract(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/customer/turnedContract', data)
}
/**
 *客户流失激活
 */
export function activation(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/customer/activation', data)
}
/**
 *客户转成交
 */
export function turnTransaction(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/saleChance/changeToDeal', data)
}
/**
 *通过客户代码查询关联商机
 */
export function saleChanceByArkCodeSelect(arkCode: string) {
  return request.get<AxiosResult, AxiosResult>(`/ofbu/api/saleChance/getByArkCode/${arkCode}`)
}
/**
 *客户关联代码
 */
export function bindARKCode(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/customer/bindARKCode', data)
}
/**
 *根据客户代码查询关联客户信息
 */
export function queryCodeRel(arkCode: string) {
  return request.get<AxiosResult, AxiosResult>(`/ofbu/api/customerCode/${arkCode}/queryCodeRel`)
}
/**
 *根据客户查询商机列表
 */
export function saleChanceByArkCodeList(arkCode: any) {
  return request.get<AxiosResult, AxiosResult>(`/ofbu/api/saleChance/getByArkCode/${arkCode}`)
}
/**
 *根据客户代码查询商机列表
 */
export function saleChanceByCosId(cosId: any) {
  return request.get<AxiosResult, AxiosResult>(`/ofbu/api/saleChance/getByCosId/${cosId}`)
}
/**
 *修改合同编码
 */
export function contractCodeUpdate(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/customer/contractCodeUpdate', data)
}
/**
 *转化记录
 */
export function conversionList(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/conversion/log/page/list', data)
}
/**
 *客户合并
 */
export function customerMerge(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/customer/merge', data)
}

/**
 * ************************************** 签约主体 **************************************
 */
//  获取签约主体列表数据
export function mainBodyList(data?: MainBodyParams) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/signed/subject/page/list', data)
}
//  获取签约主体详情数据
export function mainBodyDetail(data: IDParams) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/signed/subject/detail', data)
}
